<template>
  <div :class="referer == 'message' ? 'inbox-right' : 'inbox-i-detail'">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div style="width:100%; height:100%" v-if="permission">
      <div class="inbox-nomessage-wrap" v-if="ig_info == ''">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">Instagramアカウントが連携されていません</div>
          <div style="margin-bottom: 30px;">アカウントを連携するとDMの送受信が行えます</div>
          <el-button type="primary" @click="toConnectSetting()">アカウント連携</el-button>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="ig_selected == ''">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">アカウントが選択されていません</div>
          <div style="margin-bottom: 30px;">アカウントを選択すると個別メッセージを確認できます</div>
          <div style="opacity: 0.7">
            <connectAccount @error-message-check="handleConnectAccountError"/>
          </div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="referer == 'message' ? thread_id == '' : ig_id == ''">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">メッセージが選択されていません</div>
          <div style="margin-bottom: 30px;">メッセージを選択すると個別メッセージを確認できます</div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="connecting_error">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">Instagramとの連携が解除されています</div>
          <div style="margin-bottom: 30px;">連携が解除されているためメッセージを表示できません。再連携を行ってください。</div>
          <el-button type="primary" @click="toConnectSetting()">再連携を行う</el-button>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="feedback_error">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">Instagramに規制がかかっています</div>
          <div style="margin-bottom: 30px;">InstagramアカウントにDM規制がかかっています。<br/>規制が解除されるまでしばらく時間を空けてからもう一度お試しください。
          </div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="consent_required">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">Instagramの利用規約変更への同意が必要です</div>
          <div style="margin-bottom: 30px;">
            Instagramにて利用規約・データに関するポリシーが更新されています。<br/>引き続きご利用いただくにはInstagramのスマホアプリ側にて変更点をご確認の上、同意をいただく必要がございます。
            <br/>(このアラートは同意のご確認が完了するまで継続して表示されます。)
          </div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="unloadable_participant">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">このインフルエンサーにはメッセージを送信できません</div>
          <div style="margin-bottom: 30px;">ユーザー名が変更されている、非公開アカウントになっている、ブロックされているなどの原因が考えられます。</div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="fail_get_message">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">個別メッセージの取得に失敗しました。</div>
          <div style="margin-bottom: 30px;">連携アカウントを確認の上、リロードしてください。</div>
        </div>
      </div>
      <div class="inbox-nomessage-wrap" v-else-if="other_error">
        <div class="inbox-nomessage">
          <img src="../../assets/new_message.png" style="opacity:0.5" alt/>
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">システムエラーが発生しました。</div>
          <div style="margin-bottom: 30px;">一度ログインをしなおしてから操作を行ってください。それでも解消されない場合はお問い合わせください。</div>
        </div>
      </div>
      <div class="inbox-message-wrap" v-else>
        <div class="thread-title">
          <transition name="fade">
            <div v-if="!thread_loading && thread_data.users" class="flex-row">
              <div
                  class="thread-title-userarea"
                  :class="referer == 'message' && thread_data.exist_user ? 'pointer' : ''"
                  @click="referer == 'message' && thread_data.exist_user ? openDrawer(thread_data.users[0].username) : ''"
              >
                <div class="thread-imagearea">
                  <div class="thread-online" v-if="target_presence.is_active"></div>
                  <el-image :src="target_pic_url" class="thread-profile" referrer-policy="no-referrer">
                    <div slot="error" class="data-table-profile-noimg">
                      NO
                      <br/>IMAGE
                    </div>
                  </el-image>
                </div>
                <div class="thread-title-username"
                     :class="referer == 'message' && thread_data.exist_user ? '' : 'i-detail'">
                  {{ thread_data.users[0].username }}・{{ thread_data.users[0].full_name }}
                  <font-awesome-icon v-show="referer == 'message' && thread_data.exist_user"
                                     :icon="['fal', 'info-circle']" style="margin-left:3px; color:#666"/>
                </div>
              </div>
              <transition name="fade">
                <div v-if="target_presence != ''" style="margin-left:10px; color:#666">
                  <span v-if="target_presence.is_active">オンライン中</span>
                  <span v-else>{{ target_presence.last_activity_at_ms | lastActivity }}にオンライン</span>
                </div>
              </transition>
            </div>
          </transition>
          <div class="flex-space"></div>
          <el-tooltip content="ノートを表示">
            <div style="font-size:22px; margin-right:20px" class="pointer"
                 @click="referer == 'message' && thread_data.exist_user ? openDrawer(thread_data.users[0].username, true) : ''">
              <font-awesome-icon :icon="['far', 'file-alt']" style="color: #ccc"
                                 v-if="referer == 'message' && thread_data.exist_user"/>
            </div>
          </el-tooltip>
          <el-tooltip content="再読み込み">
            <span class="pointer" style="margin-right: 20px;"
                  @click="referer == 'idetail' ? userThread() : openThread()">
              <font-awesome-icon :icon="['far', 'redo-alt']" style="font-size: 20px; color: #ccc"/>
            </span>
          </el-tooltip>
          <el-tooltip content="ラベル">
            <div style="font-size: 20px; margin-right:20px" class="pointer" @click="labelThread()">
              <font-awesome-icon v-if="thread_label" :icon="['fas', 'flag']" style="color: #0095f6"/>
              <font-awesome-icon v-else :icon="['far', 'flag']" style="color: #ccc"/>
            </div>
          </el-tooltip>
          <connectAccount @error-message-check="handleConnectAccountError" v-if="referer != 'message'" :referer="referer"/>
        </div>
        <div class="thread-loading" v-show="thread_loading" v-loading="thread_loading"></div>
        <div v-show="!thread_loading" class="inbox-message-itemarea scrollbar-a" id="message-itemarea">
          <div class="inbox-next-cursor" @click="ThreadCursor()" v-loading="thread_cursor_loading"
               v-if="thread_cursor != ''">
            <font-awesome-icon v-show="!thread_cursor_loading" :icon="['far', 'redo-alt']"/>
          </div>
          <div v-for="(item, item_index) in thread_items" :key="item.id" class="inbox-item-wrap"
               :class="target_id == item.user_id ? 'target' : 'viewer'" v-show="item.item_type != 'action_log'">
            <div class="inbox-time-left" v-if="target_id != item.user_id">
              <el-popover placement="top" trigger="click">
                <div class="inbox-item-delete pointer" @click="deleteItem(item.item_id, item_index)">
                  <div class="flex-row">
                    送信を取り消し
                    <div class="loader--mini blue" v-show="delete_loading"></div>
                  </div>
                </div>
                <div slot="reference" class="inbox-item-menu pointer" v-if="target_id != item.user_id">
                  <font-awesome-icon :icon="['far', 'ellipsis-h']"/>
                </div>
              </el-popover>
              <span class="inbox-timeline">
                {{ item.timestamp | timestampToTime }}
                <span v-if="item.timestamp < last_seen_at">・既読</span>
              </span>
            </div>
            <el-image :src="target_pic_url" class="thread-profile target" v-if="target_id == item.user_id"
                      referrer-policy="no-referrer">
              <div slot="error" class="data-table-profile-noimg">
                NO
                <br/>IMAGE
              </div>
            </el-image>
            <div class="inbox-item" :class="target_id == item.user_id ? 'target' : 'viewer'">
              <div v-if="item.item_type == 'generic_xma'">
                <div v-for="(xma, idx) in item.generic_xma" :key="idx" style="margin-bottom: 5px;">
                  <a style="color:inherit" class="pointer"
                     :href="xma.target_url || 'javascript:void(0)'" target="_blank">
                    <div class="inbox-item-link-wrap">
                      <img class="inbox-item-link-image"
                           :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + idx + '_' + h + '.jpg'"
                           v-if="xma.preview_url || (xma.preview_url_info && xma.preview_url_info.url)" 
                           alt @load="imgLoaded()"/>
                      
                      <div class="inbox-item-link-title" 
                           v-if="xma.header_title_text || xma.title_text"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                        {{ xma.header_title_text || xma.title_text }}
                      </div>
                      <div class="inbox-item-link-summary" 
                           v-if="xma.caption_body_text || xma.subtitle_text"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                         {{ xma.caption_body_text || xma.subtitle_text }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div v-if="item.item_type == 'voice_media'" style="padding: 10px;">
                <audio controls style="max-width: 250px;">
                  <source :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.mp4'" type="audio/mp4">
                  お使いのブラウザはaudioタグをサポートしていません。
                </audio>
              </div>

              <div v-if="item.item_type == 'animated_media'" style="padding: 5px;">
                <video autoplay loop muted playsinline 
                       style="max-width: 200px; border-radius: 8px; background-color: transparent;"
                       :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.mp4'"
                       @error="item.video_error = true"
                >
                </video>
                <img v-if="item.video_error"
                     :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.gif'"
                     style="max-width: 200px; border-radius: 8px;" 
                     alt="GIF" />
              </div>

              <div v-if="item.item_type == 'sticker'" style="padding: 5px;">
                <img :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.png'" 
                     style="max-width: 150px; object-fit: contain;" alt="sticker" @load="imgLoaded()"/>
              </div>

              <div v-if="item.item_type == 'location'">
                 <a :href="'https://www.google.com/maps/search/?api=1&query=' + (item.location.address || item.location.name)" target="_blank" style="text-decoration:none; color:inherit;">
                   <div class="inbox-item-link-wrap">
                     <div class="inbox-item-link-title"
                          :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                       {{ item.location.name }}
                     </div>
                     <div class="inbox-item-link-summary"
                          :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                       {{ item.location.address }}
                     </div>
                   </div>
                 </a>
              </div>

              <div v-if="item.item_type == 'video_call_event'" 
                   :style="{ 
                     color: target_id == item.user_id ? '#333' : '#fff' , 
                     fontSize: '12px', 
                     textAlign: 'center',
                     width: '100%',
                     opacity: 0.8 
                   }">
                
                <span v-if="item.video_call_event && item.video_call_event.description">
                    {{ item.video_call_event.description }}
                </span>
                <span v-else>
                    ビデオ通話 / 音声通話
                </span>
              </div>

              <pre v-if="isShowText(item) && item.item_type != 'xma_story_share'"><span v-html="$options.filters.urlActivate(getDisplayContent(item))"></span></pre>

              <a style="color:inherit" class="pointer" v-if="item.item_type == 'xma_story_share'"
                 :href="item.xma_story_share[0].target_url || 'javascript:void(0)'" target="_blank">
                <div class="inbox-item-link-wrap">
                  
                  <img class="inbox-item-link-image"
                       :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.jpg'"
                       v-if="hasPreviewImage(item)"
                       alt=""
                       @load="imgLoaded()"
                       style="width: auto; max-width: 100%; height: 250px; object-fit: contain; object-position: center; display: block; margin: 0 auto;"
                  />
                  <div v-else style="height: 250px; background-color: rgb(0 0 0 / 0.05); display: flex; align-items: center; justify-content: center; color: #fff; font-size: 12px;">
                      ストーリーを表示できません
                  </div>
                  
                  <div style="padding: 10px 12px;">
                      <div style="display: flex; align-items: center;" v-if="item.xma_story_share[0].header_title_text">
                        <div class="inbox-item-link-title"
                             :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                            {{ item.xma_story_share[0].header_title_text }}
                        </div>
                      </div>
                      
                      <div class="inbox-item-link-summary" 
                           style="margin-top: 2px;"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }" 
                           v-if="item.text">
                          {{ item.text }}
                      </div>
                  </div>
                </div>
              </a>

              <a style="color:inherit" class="pointer" 
                 v-if="['link', 'xma_link', 'xma_reel_mention', 'xma_clip', 'xma_reel_share', 'xma_media_share', 'xma_profile', 'felix_share', 'live_video_share', 'xma'].includes(item.item_type)"
                 :href="getTargetUrl(item)" :target="getTargetUrl(item) ? '_blank' : ''">
                
                <div class="inbox-item-link-wrap">
                  
                  <div v-if="item.item_type == 'xma_media_share' || item.item_type == 'xma'" 
                       style="display: flex; align-items: center; padding: 8px 12px;">
                    <img :src="s3BaseUrl + '/userdata/' + item.item_id + '_icon_' + h + '.jpg'" 
                         style="width: 32px; height: 32px; border-radius: 50%; margin-right: 10px; object-fit: cover; background-color: #f0f0f0;" alt=""/>
                    <div style="font-weight: bold; font-size: 13px;"
                         :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                        {{ getXmaTitle(item) }}
                    </div>
                  </div>

                  <img class="inbox-item-link-image"
                       :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.jpg'"
                       v-if="hasPreviewImage(item)"
                       :style="item.item_type == 'xma_profile' ? 'object-fit: contain; background-color: #f0f0f0;' : ''"
                       alt @load="imgLoaded()"/>
                  
                  <div class="inbox-item-link-title" 
                       v-if="item.item_type != 'xma_media_share' && item.item_type != 'xma' && getXmaTitle(item)"
                       :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                    {{ getXmaTitle(item) }}
                  </div>

                   <div style="padding: 8px 12px;" v-if="item.item_type == 'xma_media_share' && (getXmaSummary(item) || item.xma_media_share[0].title_text)">
                      <div style="font-size: 13px; margin-bottom: 2px;" 
                           v-if="item.xma_media_share[0].title_text"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                          {{ item.xma_media_share[0].title_text }}
                      </div>
                      <div style="font-size: 12px; line-height: 1.3;" 
                           v-if="getXmaSummary(item)"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                          {{ getXmaSummary(item) }}
                      </div>
                  </div>

                  <div class="inbox-item-link-summary" 
                       v-if="item.item_type != 'xma_media_share' && getXmaSummary(item)"
                       :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                     {{ getXmaSummary(item) }}
                  </div>
                </div>
              </a>

              <a style="color:inherit" class="pointer" 
                 v-if="item.item_type == 'location_share_xma' && item.location_share_xma && item.location_share_xma[0]"
                 :href="item.location_share_xma[0].target_url || 'javascript:void(0)'" target="_blank">
                <div class="inbox-item-link-wrap">
                  
                  <div style="display: flex; align-items: center; padding: 8px 12px;">
                    <img :src="s3BaseUrl + '/userdata/' + item.item_id + '_icon_' + h + '.png'" 
                         style="width: 24px; height: 24px; margin-right: 8px; object-fit: contain;" alt=""/>
                    
                    <div class="inbox-item-link-title"
                         :style="{ color: target_id == item.user_id ? '#333' : '#fff' }"
                         style="margin: 0;">
                        {{ item.location_share_xma[0].header_title_text }}
                    </div>
                  </div>

                  <img class="inbox-item-link-image"
                       :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.jpg'"
                       v-if="hasPreviewImage(item)"
                       alt=""
                       @load="imgLoaded()"
                       style="width: auto; max-width: 100%; height: 150px; object-fit: contain; object-position: center; display: block; margin: 0 auto;"
                  />
                  <div v-else style="height: 150px; background-color: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999;">
                      Map Preview
                  </div>

                  <div style="padding: 8px 12px;">
                      <div class="inbox-item-link-summary"
                           :style="{ color: target_id == item.user_id ? '#333' : '#fff' }">
                          {{ item.location_share_xma[0].header_subtitle_text }}
                      </div>
                  </div>
                </div>
              </a>
              
              <div v-if="!isKnownType(item.item_type)"
                  :style="{ 
                    color: target_id == item.user_id ? '#666' : '#fff', 
                    fontSize: '12px', 
                    opacity: 0.8 
                  }">                
                {{ item.text || '(未対応のメッセージ形式: ' + item.item_type + ')' }}
              </div>
              <div v-if="item.reel_share && item.reel_share.type == 'mention'" class="inbox-item-mention">
                ストーリーズでメンションしました
              </div>
              <div v-if="item.reel_share && item.reel_share.type == 'reply'">
                <div class="inbox-item-mention">ストーリーズに返信しました</div>
                {{ item.reel_share.text || item.text }}
              </div>
              <div v-if="item.reel_share && item.reel_share.type == 'reaction'">
                <div class="inbox-item-mention">ストーリーズにリアクションしました</div>
                {{ item.reel_share.text || item.text }}
              </div>
              <div v-if="item.raven_media && item.view_mode != 'permanent'" class="inbox-item-mention">
                このタイプのメッセージを表示するには、Instagramアプリを使用してください。
              </div>
              <div v-if="item.item_type == 'placeholder'" class="inbox-item-mention">{{
                  item.placeholder.message
                }}
              </div>
              <el-image
                  :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.jpg'"
                  class="thread-media"
                  :class="target_id == item.user_id ? 'target' : 'viewer'"
                  v-if="item.item_type == 'media'"
                  referrer-policy="noreferrer"
                  @load="imgLoaded()"
              ></el-image>
              <el-image
                  :src="s3BaseUrl + '/userdata/' + item.item_id + '_' + h + '.jpg'"
                  class="thread-media"
                  :class="target_id == item.user_id ? 'target' : 'viewer'"
                  v-if="item.item_type == 'raven_media' && item.view_mode == 'permanent'"
                  @load="imgLoaded()"
              >
              </el-image>
              <div v-if="item.item_type == 'media_share'">
                <div class="thread-media-share-wrap" v-if="item.direct_media_share">
                  <div
                      class="thread-media-share-userarea"
                      :class="item.direct_media_share.media.user.exist_user ? 'pointer' : ''"
                      @click="
                      item.direct_media_share.media.user.exist_user
                        ? referer == 'message'
                          ? openDrawer(item.direct_media_share.media.user.username)
                          : openNewWindow(item.direct_media_share.media.user.username)
                        : ''
                    "
                  >
                    <div class="thread-media-share-user-image">
                      <el-image
                          :src="s3BaseUrl + '/profile_picture/' + item.direct_media_share.media.user.username + '.jpg'"
                          class="thread-profile"
                          referrer-policy="no-referrer"
                          @load="imgLoaded()"
                      >
                        <div slot="error" class="data-table-profile-noimg">NO<br/>IMAGE</div>
                      </el-image>
                    </div>
                    <div class="thread-media-share-user-namearea">
                      <div class="thread-media-share-user-name"
                           :class="item.direct_media_share.media.user.exist_user ? 'underline' : ''">
                        {{ item.direct_media_share.media.user.username }}
                        <font-awesome-icon :icon="['fal', 'exclamation-circle']"
                                           v-if="item.direct_media_share.media.user.exist_user"
                                           style="margin-left: 3px;"/>
                      </div>
                      <div class="thread-media-share-user-name-bottom"
                           v-if="item.direct_media_share.media.sponsor_tags">
                        {{ item.direct_media_share.media.sponsor_tags[0].sponsor.username }}とのタイアップ投稿
                      </div>
                    </div>
                  </div>
                  <a :href="'https://instagram.com/p/' + item.direct_media_share.media.code + '/'" target="_blank">
                    <div class="thread-media-share-link pointer" @mouseover="mouseover = item_index"
                         @mouseleave="mouseover = -1">
                      <el-image
                          :src="s3BaseUrl + '/post_data/' + item.direct_media_share.media.code + '_m.jpg'"
                          class="thread-media-share"
                          referrer-policy="noreferrer"
                          @load="imgLoaded()"
                      >
                      </el-image>
                    </div>
                  </a>
                  <div class="thread-media-share-description">
                    <span>{{ item.direct_media_share.media.caption.text }}</span>
                  </div>
                </div>
                <div class="thread-media-share-wrap" v-else-if="item.media_share">
                  <div
                      class="thread-media-share-userarea"
                      :class="item.media_share.user.exist_user ? 'pointer' : ''"
                      @click="item.media_share.user.exist_user ? (referer == 'message' ? openDrawer(item.media_share.user.username) : openNewWindow(item.media_share.user.username)) : ''"
                  >
                    <div class="thread-media-share-user-image">
                      <el-image
                          :src="s3BaseUrl + '/profile_picture/' + item.media_share.user.username + '.jpg'"
                          class="thread-profile"
                          referrer-policy="no-referrer"
                          @load="imgLoaded()"
                      >
                        <div slot="error" class="data-table-profile-noimg">NO<br/>IMAGE</div>
                      </el-image>
                    </div>
                    <div class="thread-media-share-user-namearea">
                      <div class="thread-media-share-user-name"
                           :class="item.media_share.user.exist_user ? 'underline' : ''">
                        {{ item.media_share.user.username }}
                        <font-awesome-icon :icon="['fal', 'exclamation-circle']" v-if="item.media_share.user.exist_user"
                                           style="margin-left: 3px;"/>
                      </div>
                      <div class="thread-media-share-user-name-bottom" v-if="item.media_share.sponsor_tags">
                        {{ item.media_share.sponsor_tags[0].sponsor.username }}とのタイアップ投稿
                      </div>
                    </div>
                  </div>
                  <a :href="'https://instagram.com/p/' + item.media_share.code + '/'" target="_blank">
                    <div class="thread-media-share-link pointer" @mouseover="mouseover = item_index"
                         @mouseleave="mouseover = -1">
                      <el-image
                          :src="s3BaseUrl + '/post_data/' + item.media_share.code + '_m.jpg'"
                          class="thread-media-share"
                          referrer-policy="noreferrer"
                          @load="imgLoaded()"
                      >
                      </el-image>
                    </div>
                  </a>
                  <div class="thread-media-share-description">
                    <span>{{ item.media_share.caption.text }}</span>
                  </div>
                </div>
              </div>
              <div class="inbox-like" v-if="item.reactions">
                <font-awesome-icon :icon="['fas', 'heart']"/>
              </div>
            </div>
            <el-image
                :src="s3BaseUrl + '/profile_picture/' + ig_selected.account_name + '.jpg'"
                class="thread-profile viewer"
                v-if="target_id != item.user_id"
            >
              <div slot="error" class="data-table-profile-noimg">
                NO
                <br/>IMAGE
              </div>
            </el-image>
            <div class="inbox-time" v-if="target_id == item.user_id">
              <el-popover placement="top" trigger="click">
                <div class="loader--mini blue" v-if="reaction_loading"></div>
                <div v-else-if="!item.reactions" class="inbox-item-delete pointer"
                     @click="sendReaction(item_index, item.item_id, 'created')">
                  いいね！
                </div>
                <div v-else class="inbox-item-delete pointer"
                     @click="sendReaction(item_index, item.item_id, 'deleted')">
                  いいねを取り消す
                </div>
                <div slot="reference" class="inbox-item-menu pointer" v-if="target_id == item.user_id">
                  <font-awesome-icon :icon="['far', 'ellipsis-h']"/>
                </div>
              </el-popover>
              {{ item.timestamp | timestampToTime }}
            </div>
          </div>
          <div class="inbox-item-wrap viewer" v-if="sendMessage_loading">
            <div class="inbox-item viewer">
              <div class="flex-row">
                メッセージを送信中です...
                <div class="loader--mini"></div>
              </div>
            </div>
            <el-image
                :src="s3BaseUrl + '/profile_picture/' + ig_selected.account_name + '.jpg'"
                class="thread-profile viewer">
              <div slot="error" class="data-table-profile-noimg">
                NO
                <br/>IMAGE
              </div>
            </el-image>
          </div>
        </div>
        <div class="inbox-input-area">
          <div class="inbox-input">
            <textarea
                v-model="chat_value"
                placeholder="メッセージを入力..."
                class="inbox-textarea scrollbar-a"
                :rows="textarea_rows"
                :style="'height:' + textarea_height + 'px'"
                @input="inputMessage()"
                @keydown.ctrl.enter.exact="sendMessage()"
                @keydown.meta.enter.exact="sendMessage()"
                @compositionstart="composing = true"
                @compositionend="composing = false"
                wrap="soft"
            ></textarea>
            <div class="inbox-input-buttonarea">
              <el-tooltip>
                <div slot="content">テンプレート</div>
                <font-awesome-icon class="pointer" :icon="['fal', 'comment-alt-dots']"
                                   @click="phrase_select_drawer = true"/>
              </el-tooltip>
              <phraseSelect v-if="phrase_select_drawer" :phrase_select_drawer.sync="phrase_select_drawer"
                            @selectPhrase="selectPhrase"/>
              <div class="phrase-select-overlay" v-if="phrase_select_drawer"
                   @click="phrase_select_drawer = false"></div>
              <div class="pointer">
                <el-tooltip>
                  <div slot="content">写真を送信</div>
                  <font-awesome-icon @click="img_send = true" :icon="['far', 'image-polaroid']"
                                     style="color: #666; font-size:16px; margin-left:15px"/>
                </el-tooltip>
              </div>
              <div style="font-size:10px; color:#aaa; margin-left:10px"
                   v-if="!inputting && inputting_id > 0 && chat_value != ''">
                <el-tooltip content="この画面から遷移しても入力中のメッセージは維持されます。">
                  <span>メッセージが下書き保存されました</span>
                </el-tooltip>
              </div>
              <div class="flex-space"></div>
              <div class="inbox-input-length" :class="chat_value.length > 1000 ? 'limit' : ''">{{
                  chat_value.length
                }}/1000
              </div>
              <el-button type="small" :disabled="!chat_value.match(/\S/g) || preview_drawer"
                         @click="preview_drawer = true">プレビュー
              </el-button>
              <el-button type="primary" size="small" :disabled="!chat_value.match(/\S/g) || chat_value.length > 1000"
                         @click="sendMessage()">送信 (Ctrl+Enter)
              </el-button>
            </div>
            <div style="font-size:10px; color:#f56c6c;" v-if="!thread_data.exist_user && include_personal_items">
              <el-tooltip content="報酬金額に関するパーソナライズ項目が挿入されている場合、その項目はブランクで送信されます">
                <span>
                  <font-awesome-icon :icon="['far', 'exclamation-triangle']"/>
                  {{ siteName }} に登録されていないアカウントのため、一部のパーソナライズ項目が使用できません。
                </span>
              </el-tooltip>
            </div>
            <div style="font-size:10px; color:#f56c6c; padding-top: 3px;" v-if="reel_url_exist">
              <span>
                <font-awesome-icon :icon="['far', 'exclamation-triangle']"/>
               ※送信メッセージにInstagramのリール投稿URLが含まれます。環境によって正しく表示されない事がある為、メッセージを分割して送信する場合がございます（１通目は投稿IDのみ表記、２通目にリール投稿URLを送ります）。リクエスト承認待ち状態になった場合は動画IDのみ送信される形となります。
              </span>
            </div>
            <div style="font-size:10px; color:#f56c6c;" v-if="chat_value.length > 900">
              <el-tooltip content="パーソナライズ項目を含め、1000字以内になるようにご注意ください。送信先ごとにプレビューを確認してください。">
                <span>
                  <font-awesome-icon :icon="['far', 'exclamation-triangle']"/>
                  パーソナライズ項目を含め、1000字以内になるようにご注意ください。送信先ごとにプレビューを確認してください。
                </span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>

      <!-- プレビュー -->
      <messagePreview :preview_drawer.sync="preview_drawer" :minimize="false" :message="chat_value"
                      :recipient="recipient" :preview_index="0"
                      :type="referer == 'message' ? 'single-left' : 'single-right'"/>

      <!-- 画像送信 -->
      <transition name="fade">
        <div class="phrase-overlay" v-if="img_send">
          <div class="create-phrase-wrap" style="width:400px">
            <div class="newmessage-title">
              画像の送信
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="img_send = false">
                <font-awesome-icon :icon="['fal', 'times']"/>
              </div>
            </div>
            <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" limit="1" :file-list="fileList"
                       class="send-img" accept="image/*">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                画像をドロップ
                <em>もしくは選択してください</em>
              </div>
              <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
            </el-upload>
            <div class="list-create-footer" style="margin-top:20px">
              <el-button @click="(img_send = false), (fileList = [])">キャンセル</el-button>
              <el-button type="primary" @click="sendImg()" :disabled="file == ''">送信</el-button>
            </div>
          </div>
        </div>
      </transition>

      <!-- テンプレート作成 -->
      <transition name="fade">
        <phrase v-if="phrase_drawer" :phrase_drawer="phrase_drawer" :phrase_info="phrase_info"
                :phrase_type="phrase_type" @closePhrase="closePhrase()" @loadPhrase="loadPhrase()"/>
      </transition>

      <!-- drawer -->
      <div :class="[drawer ? 'i-detail-modal open' : 'i-detail-modal']" id="i-detail-scroll">
        <router-view ref="iDetail" v-if="drawer"></router-view>
      </div>
      <div class="overlay" :class="[drawer ? 'overlay open' : 'overlay']" @click="closeDrawer"></div>
    </div>
    <unpermitted style="margin-top: 100px;" v-else/>


  </div>
</template>

<script>

import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const threadAPI = root + "/api/message/thread";
const userThreadAPI = root + "/api/message/user_thread";
const saveMessageAPI = root + "/api/message/save_message";
const seenAPI = root + "/api/message/seen";
const labelAPI = root + "/api/message/label";
const deleteItemAPI = root + "/api/message/delete";
const broadCastAPI = root + "/api/message/broadcast";
const getPresenceAPI = root + "/api/message/get_presence";
const loadPhraseAPI = root + "/api/message/load_phrase";
const reelUrlRegex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/reel\/[A-Za-z0-9_-]+(?:[/?#][^\s]*)?/i;
// const urlRegex = /((?:https:\/\/)|(?:http:\/\/)|(?:www\.))?([a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(?:\?\/)[a-zA-Z0-9\-._?,'/\\+&%$#=~]+)/g;
import phrase from "./phrase_drawer.vue";
import connectAccount from "./connect_account.vue";
import unpermitted from "./../unpermitted.vue";
import phraseSelect from "../message/phrase_select.vue";
import messagePreview from "../message/message_preview.vue";

export default {
  name: "inboxDetail",
  components: {
    UserTokenSiteInfo,
    phrase,
    connectAccount,
    unpermitted,
    phraseSelect,
    messagePreview,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  props: ["referer", "thread_id", "ig_id"],
  data() {
    return {
      thread_data: [],
      thread_items: [],
      thread_label: false,
      thread_cursor: "",
      thread_cursor_loading: false,
      thread_cursor_loaded: false,
      thread_loading: false,
      last_seen_at: "",
      target_id: "",
      target_pic_url: "",
      target_presence: [],
      requestId: 0,
      drawer: false,
      chat_value: "",
      phrase_drawer: false,
      phrase_list: [],
      phrase_info: [],
      phrase_type: "open",
      newphrase: {
        title: "",
        content: "",
      },
      bulk_drawer: false,
      delete_loading: false,
      connecting_error: false,
      feedback_error: false,
      consent_required: false,
      unloadable_participant: false,
      fail_get_message: false,
      other_error: false,
      sendMessage_loading: false,
      img_send: false,
      file: "",
      fileList: [],
      dragenter: false,
      h: "",
      reaction_loading: false,
      inputting: false,
      inputting_id: 0,
      mouseover: -1,
      phrase_select_drawer: false,
      preview_drawer: false,
      recipient: {},
      connectAccountCheck: false,
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.message.access;
    },
    textarea_rows() {
      var num = this.chat_value.split("\n").length;
      return num > 10 ? 11 : num > 1 ? num : 1;
    },
    textarea_height() {
      return this.textarea_rows * 17;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    sessionid() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.sessionid;
      } else {
        return null;
      }
    },
    csrftoken() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.csrftoken;
      } else {
        return null;
      }
    },
    include_personal_items() {
      if (this.chat_value.match(/\{\{DM用報酬金額\}\}|\{\{報酬:フォロワー数×[0-9.]+円\}\}/)) {
        return true;
      } else {
        return false;
      }
    },
    reel_url_exist() {
      return reelUrlRegex.test(this.chat_value);
    },
  },
  mounted() {
    if (this.referer == "idetail" && this.ig_selected != "") {
      this.userThread();
    }
    this.loadPhrase();
  },
  methods: {
    openThread() {
      this.thread_loading = true;
      this.connecting_error = false;
      this.feedback_error = false;
      this.consent_required = false;
      this.unloadable_participant = false;
      this.fail_get_message = false;
      this.other_error = false;
      this.sendMessage_loading = false;
      this.thread_cursor = ""; //カーソルのリセット
      this.target_presence = [];
      this.chat_value = "";
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("sessionid", this.sessionid);
      params.append("thread_id", this.thread_id);
      params.append("user_token", this.user_token);
      params.append("token", this.token);
      this.axios
          .post(threadAPI, params, {
            requestId: this.requestId,
          })
          .then((response) => {
            if (response.data.status == "NG") {
              if (response.data.code == 400) {
                this.fail_get_message = true;
              } else {
                this.other_error = true;
              }
              this.thread_data = "";
            } else if (response.data.status == "fail") {
              if (response.data.message == "Unloadable participant") {
                this.unloadable_participant = true;
                this.thread_data = "";
              } else if (response.data.message == "consent_required") {
                this.consent_required = true;
                this.thread_data = "";
              } else if (response.data.message == "feedback_required") {
                this.feedback_error = true;
                this.thread_data = "";
              } else {
                this.connecting_error = true;
                this.thread_data = "";
              }
            } else {
              this.chat_value = response.data.message_draft;
              this.thread_data = response.data.thread;
              this.thread_items = response.data.thread.items;
              this.h = response.data.h;
              this.target_id = response.data.thread.users[0].pk;
              this.target_pic_url = this.s3BaseUrl + "/profile_picture/" + response.data.thread.users[0].username + ".jpg";
              this.recipient = response.data.for_preview; //プレビュー用
              //cusor取得
              if (response.data.thread.has_older) {
                this.thread_cursor = response.data.thread.oldest_cursor;
              } else {
                this.thread_cursor = "";
              }
              //既読状況確認
              if (response.data.thread.last_seen_at[this.target_id]) {
                this.last_seen_at = response.data.thread.last_seen_at[this.target_id].timestamp;
              } else {
                this.last_seen_at = "";
              }
              //時系列順に並び替え
              this.thread_items.sort(function (a, b) {
                return a.timestamp < b.timestamp ? -1 : 1;
              });
              //label
              if (response.data.thread.thread_label == 1) {
                this.thread_label = true;
              } else {
                this.thread_label = false;
              }
              // seen FIXME 2026-02-05 現在、正常なレスポンスが返ってこず不審なアクセスと検知される可能性があるため、一旦コメントアウト
              // this.getPresence();
              // this.seenItem();
              this.$nextTick(() => {
                this.scrollBottom();
              });
            }
            this.thread_loading = false;
          }).catch((error) => {
            if (!this.axios.isCancel(error)) {
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "メッセージの取得に失敗しました。ページを再読み込みしてください。",
              });
            }
          });
    },
    userThread() {
      this.thread_loading = true;
      this.connecting_error = false;
      this.feedback_error = false;
      this.consent_required = false;
      this.unloadable_participant = false;
      this.fail_get_message = false;
      this.other_error = false;
      this.sendMessage_loading = false;
      this.thread_cursor = ""; //カーソルのリセット
      this.target_presence = [];
      this.chat_value = "";
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("sessionid", this.sessionid);
      params.append("csrftoken", this.csrftoken);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("recipient_user", this.ig_id);
      this.axios.post(userThreadAPI, params).then((response) => {
        if (response.data.status == "NG") {
          if (response.data.code == 400) {
            this.fail_get_message = true;
          } else if (response.data.code == 403) {
            this.unloadable_participant = true;
          } else {
            this.other_error = true;
          }
          this.thread_data = "";
        } else if (response.data.status == "fail") {
          if (response.data.message == "Unloadable participant") {
            this.unloadable_participant = true;
            this.thread_data = "";
          } else if (response.data.message == "consent_required") {
            this.consent_required = true;
            this.thread_data = "";
          } else if (response.data.message == "feedback_required") {
            this.feedback_error = true;
            this.thread_data = "";
          } else if (response.data.message == "エラーが発生しました。もう一度実行してください。 Client context:client_context_not_available") {
            this.feedback_error = true;
            this.thread_data = "";
          } else {
            this.connecting_error = true;
            this.thread_data = "";
          }
        } else {
          this.chat_value = response.data.message_draft;
          this.thread_data = response.data;
          this.target_id = response.data.users[0].pk;
          this.h = response.data.h;
          this.target_pic_url = this.s3BaseUrl + "/profile_picture/" + response.data.users[0].username + ".jpg";
          this.recipient = response.data.for_preview; //プレビュー用
          this.thread_id = response.data.thread_id;
          if (response.data.items != "") {
            this.thread_items = response.data.items;
            //時系列順に並び替え
            this.thread_items.sort(function (a, b) {
              return a.timestamp < b.timestamp ? -1 : 1;
            });
            this.seenItem();
          } else {
            this.thread_items = [];
          }
          //cusor取得
          if (response.data.has_older) {
            this.thread_cursor = response.data.oldest_cursor;
          } else {
            this.thread_cursor = "";
          }
          //既読状況確認
          if (response.data.last_seen_at[this.ig_id]) {
            this.last_seen_at = response.data.last_seen_at[this.ig_id].timestamp;
          } else {
            this.last_seen_at = "";
          }
          //label
          if (response.data.thread_label == 1) {
            this.thread_label = true;
          } else {
            this.thread_label = false;
          }
          this.$nextTick(() => {
            this.scrollBottom();
          });
        }
        this.thread_loading = false;
      });
    },
    ThreadCursor() {
      this.thread_cursor_loaded = true;
      this.thread_cursor_loading = true;
      this.unloadable_participant = false;
      this.consent_required = false;
      this.feedback_error = false;
      this.connecting_error = false;
      this.fail_get_message = false;
      this.other_error = false;
      this.sendMessage_loading = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("sessionid", this.sessionid);
      params.append("thread_id", this.thread_id);
      params.append("cursor", this.thread_cursor);
      params.append("token", this.token);
      this.axios
          .post(threadAPI, params, {
            requestId: this.requestId,
          })
          .then((response) => {
            if (response.data.status == "NG") {
              if (response.data.code == 400) {
                this.fail_get_message = true;
              } else {
                this.other_error = true;
              }
              this.thread_data = "";
              this.thread_cursor = "";
            } else if (response.data.status == "fail") {
              if (response.data.message == "Unloadable participant") {
                this.unloadable_participant = true;
                this.thread_data = "";
              } else if (response.data.message == "consent_required") {
                this.consent_required = true;
                this.thread_data = "";
              } else if (response.data.message == "feedback_required") {
                this.feedback_error = true;
                this.thread_data = "";
              } else {
                this.connecting_error = true;
                this.thread_data = "";
              }
              this.thread_cursor = "";
            } else if (response.data.thread.has_older) {
              this.thread_cursor = response.data.thread.oldest_cursor;
            } else {
              this.thread_cursor = "";
            }
            var new_items = this.thread_items.concat(response.data.thread.items);
            this.thread_items = new_items;
            this.thread_items.sort(function (a, b) {
              return a.timestamp < b.timestamp ? -1 : 1;
            });
            this.thread_cursor_loading = false;
          });
    },
    labelThread() {
      if (this.thread_label) {
        var thread_label = 0;
        this.thread_label = false;
      } else {
        thread_label = 1;
        this.thread_label = true;
      }
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("thread_id", this.thread_id);
      params.append("label", thread_label);
      params.append("sessionid", this.sessionid);
      params.append("csrftoken", this.csrftoken);
      this.axios.post(labelAPI, params).then(() => {
        this.$emit("labelThread", thread_label);
      });
    },
    seenItem() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("thread_id", this.thread_id);
      params.append("item_id", this.thread_data.last_permanent_item.item_id);
      params.append("sessionid", this.sessionid);
      params.append("csrftoken", this.csrftoken);
      this.axios.post(seenAPI, params).then(() => {
        if (this.thread_data.read_state > 0) {
          var unseen_count = this.ig_selected.unseen_count - 1;
          this.$store.dispatch("IGAccountUpdate", unseen_count);
        }
      });
    },
    deleteItem(item_id, item_index) {
      this.delete_loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("thread_id", this.thread_data.thread_id);
      params.append("item_id", item_id);
      params.append("sessionid", this.sessionid);
      params.append("csrftoken", this.csrftoken);
      params.append("useragent", window.navigator.userAgent);
      this.axios.post(deleteItemAPI, params).then((response) => {
        if (response.data.status == "ok") {
          this.thread_items.splice(item_index, 1);
        }
        this.delete_loading = false;
      });
    },
    getPresence() {
      this.axios
          .get(getPresenceAPI, {
            params: {
              token: this.token,
              sessionid: this.sessionid,
            },
          })
          .then((response) => {
            var presence = response.data.user_presence || {};
            var users = Object.keys(presence);
            for (let i = 0; i < users.length; i++) {
              if (Number(users[i]) == this.target_id) {
                this.target_presence = presence[users[i]];
              }
            }
          });
    },
    newLine() {
      this.chat_value += "\n";
    },
    inputMessage() {
      this.inputting = true;
      this.inputting_id += 1;
      var this_id = this.inputting_id;
      setTimeout(() => {
        if (this_id == this.inputting_id) this.inputting = false;
      }, 1000);
    },
    saveMessage() {
      var params = new URLSearchParams();
      params.append("ig_id", this.ig_id);
      params.append("sessionid", this.sessionid);
      params.append("message", this.chat_value);
      params.append("user_token", this.user_token);
      params.append("token", this.token);
      this.axios
          .post(saveMessageAPI, params)
          .then(() => {
          })
          .catch(() => {
          });
    },
    sendMessage() {
      if (this.connectAccountCheck) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "DM送信が一時的に使用できません。しばらく時間を置いてから行なってください。",
        });
      } else if (this.chat_value.length > 1000) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "メッセージが長すぎます",
        });
      } else if (!this.chat_value.match(/\S/g)) {
        console.log("no message");
      } else {
        if (this.composing) {
          this.composing = false;
        } else {
          this.thread_cursor_loaded = false;
          this.sendMessage_loading = true;
          var message = this.chat_value;
          message = message.replace(/＠/g, "@"); //全角アットマークがエラーになるため半角に変換
          // var del_strmark_message = message.replace(/\{\{.*\}\}/g, ''); //{{}}で囲っているテキストをURL判定しないように空に変換
          // var urls = del_strmark_message.match(urlRegex);//ライブラリから自前の正規表現に変更
          // if (urls instanceof Array) {
          //   var message_type = "link";
          // } else {
          //   message_type = "text";
          // }
          var message_type = "text";
          this.$nextTick(() => {
            this.scrollBottom();
          });
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("sessionid", this.sessionid);
          // params.append("urls", JSON.stringify(urls));
          params.append("message_type", message_type);
          params.append("recipient_user_account_name", this.thread_data.users[0].username);
          params.append("recipient_user_name", this.thread_data.users[0].full_name);
          params.append("recipient_user", this.target_id);
          params.append("message", message);
          this.axios.post(broadCastAPI, params).then((response) => {
            if (response.data.status == "ok") {
              this.chat_value = "";
              this.sendMessage_loading = false;
              this.saveMessage();
              // スレッドの更新
              if (this.referer == 'idetail') {
                this.userThread();
              } else {
                this.openThread();
              }
              this.$nextTick(() => {
                this.scrollBottom();
              });
            } else {
              if (response.data.message) {
                if (response.data.message == "invalid url" || response.data.message.match(/link_url/)) {
                  this.sendMessage_loading = false;
                  this.$alert("メッセージ本文内に無効なURLが含まれています", "メッセージの送信に失敗しました", {
                    confirmButtonText: "OK",
                    showCancelButton: false,
                    type: "error",
                  });
                } else if (response.data.message == "Unloadable participant") {
                  this.sendMessage_loading = false;
                  this.$alert("ユーザー名が変更されている、非公開アカウントになっている、ブロックされているなどの原因が考えられます。", "メッセージの送信に失敗しました", {
                    confirmButtonText: "OK",
                    showCancelButton: false,
                    type: "error",
                  });
                } else if (response.data.message == "Character limit exceeded") {
                  this.sendMessage_loading = false;
                  this.$alert("パーソナライズ項目を含むメッセージの文字数が1000字を超えているため、送信できませんでした。", "メッセージの送信に失敗しました", {
                    confirmButtonText: "OK",
                    showCancelButton: false,
                    type: "error",
                  });
                } else {
                  this.sendMessage_loading = false;
                  this.$emit("loadInbox");
                  this.$alert("再度Instagramアカウントの連携を行ってください", "連携が解除されています", {
                    confirmButtonText: "OK",
                    showCancelButton: false,
                    type: "error",
                  });
                }
              }
            }
          })        
          .catch((error) => {
            this.sendMessage_loading = false;
              this.$emit("loadInbox");
              this.$alert(error, {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
              });
          });
        }
      }
    },
    sendImg() {
      // 写真DM（raven）は thread_id 必須
      var threadId = this.thread_id || (this.thread_data && this.thread_data.thread_id) || "";
      if (!threadId) {
        this.$alert("スレッド情報が取得できていません。画面を再読み込みしてから再度お試しください。", "画像の送信に失敗しました", {
          confirmButtonText: "OK",
          showCancelButton: false,
          type: "error",
        });
        return;
      }
      this.sendMessage_loading = true;
      this.img_send = false;
      this.$nextTick(() => {
        this.scrollBottom();
      });
      var formData = new FormData();
      formData.append("file", this.file.raw);
      formData.append("token", this.token);
      formData.append("message_type", "photo");
      formData.append("sessionid", this.sessionid);
      formData.append("recipient_user", this.target_id);
      formData.append("thread_id", threadId);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.axios
          .post(broadCastAPI, formData, config)
          .then((response) => {
            if (response.data.status == "ok") {
              this.file = "";
              this.fileList = [];
              this.sendMessage_loading = false;
              this.userThread();
              this.$nextTick(() => {
                this.scrollBottom();
              });
            } else {
              var item_index = this.thread_items.length;
              this.sendMessage_loading = false;
              this.thread_items[item_index].broadcast_error = true;
            }
          })
          .catch(() => {
            this.file = "";
            this.fileList = [];
            this.sendMessage_loading = false;
          });
    },
    sendReaction(item_index, item_id, reaction_status) {
      this.reaction_loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("sessionid", this.sessionid);
      params.append("message_type", "reaction");
      params.append("recipient_user", this.target_id);
      params.append("thread_id", this.thread_id);
      params.append("item_id", item_id);
      params.append("reaction_status", reaction_status);
      this.axios.post(broadCastAPI, params).then((response) => {
        if (response.data.status == "ok") {
          if (reaction_status == "created") {
            this.$set(this.thread_items[item_index], "reactions", {likes_count: 1});
          } else {
            this.$delete(this.thread_items[item_index], "reactions");
          }
        }
        this.reaction_loading = false;
      });
    },
    openDrawer(value, note) {
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
      this.$router.push({
        name: "direct_influencerDetailDrawer",
        params: {
          note: note ? true : false,
          account_name: value,
          child: true,
          parent_component: "direct",
        },
      });
      // this.$refs.iDetail.openParentDrawer();
    },
    openNewWindow(value) {
      let routeData = this.$router.resolve({
        name: "influencerDetail",
        params: {
          account_name: value,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeDrawer() {
      this.drawer = false;
      this.$router.push("/message");
      document.documentElement.style.overflow = "auto";
      this.$refs.iDetail.closeParentDrawer();
    },
    scrollBottom() {
      var itemArea = document.getElementById("message-itemarea");
      itemArea.scrollTop = 999999;
    },
    loadPhrase() {
      this.axios
          .get(loadPhraseAPI, {
            params: {
              token: this.token,
            },
          })
          .then((response) => {
            this.phrase_list = response.data.phrase_list;
          });
    },
    selectPhrase(phrase) {
      this.chat_value = phrase;
      this.phrase_select_drawer = false;
      this.saveMessage();
    },
    closePhrase() {
      this.phrase_drawer = false;
    },
    toConnectSetting() {
      if (this.referer == "message") {
        this.$emit("toConnectSetting");
      } else {
        this.$router.push({
          name: "message",
          query: {activeName: "connect"},
        });
      }
    },
    imgAdd(file, fileList) {
      this.file = file;
      this.fileList = fileList;
    },
    imgLoaded() {
      if (!this.thread_cursor_loaded) {
        this.$nextTick(() => {
          this.scrollBottom();
        });
      }
    },
    handleConnectAccountError(error) {
      this.connectAccountCheck = !!error;
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
    isShowText(item) {
      if (!item || typeof item !== 'object') return false;
      const types = ['text', 'link', 'xma_link', 'xma_reel_mention', 'xma_clip', 'generic_xma', 'xma_reel_share', 'xma_story_share', 'xma_media_share', 'xma_profile', 'felix_share', 'live_video_share'];
      return types.includes(item.item_type);
    },
    getDisplayContent(item) {
      if (!item || typeof item !== 'object') return '';
      return item.text || (item.item_type == 'link' ? item.link.text : '');
    },
    getTargetUrl(item) {
      if (!item || typeof item !== 'object') return '';
      if (item.item_type == 'link') return item.link.link_context.link_url;
      // xma (オブジェクト形式) の場合
      if (item.item_type == 'xma') return item.xma.target_url || 'javascript:void(0)';
      if (item[item.item_type] && item[item.item_type][0]) {
         // ライブ動画やIGTVのURL取得ロジック (簡易版)
         if(item.item_type == 'live_video_share') return 'javascript:void(0)';
        return item[item.item_type][0].target_url || 'javascript:void(0)';
      }
      return '';
    },
    hasPreviewImage(item) {
      if (!item || typeof item !== 'object') return '';
      if (item.item_type == 'link') return !!item.link.link_context.link_image_url;
      if (item.item_type == 'felix_share' || item.item_type == 'live_video_share') return true; // 保存済み前提

      // location_share_xma 対応 (preview_extra_urls_info があれば画像ありとみなす)
      if (item.item_type == 'location_share_xma') {
          return item.location_share_xma && 
                 item.location_share_xma[0] && 
                 item.location_share_xma[0].preview_extra_urls_info &&
                 item.location_share_xma[0].preview_extra_urls_info.length > 0;
      }
      // item_type: xma の場合
      if (item.item_type == 'xma') {
         return item.xma.preview_url || (item.xma.preview_url_info && item.xma.preview_url_info.url);
      }
      if (item[item.item_type] && item[item.item_type][0]) {
        const obj = item[item.item_type][0];
        if (item.item_type == 'xma_profile') return obj.header_icon_url_info || obj.header_icon_url;
        return obj.preview_url || (obj.preview_url_info && obj.preview_url_info.url);
      }
      return false;
    },
    getXmaTitle(item) {
      if (!item || typeof item !== 'object') return '';
      if (item.item_type == 'link') return item.link.link_context.link_title;
      // ★追加: item_type: xma の場合
      if (item.item_type == 'xma') return item.xma.header_title_text || item.xma.title_text;
      if (item[item.item_type] && item[item.item_type][0]) {
         const obj = item[item.item_type][0];
         return obj.header_title_text || obj.title_text;
       }
       return '';
    },
    getXmaSummary(item) {
      if (!item || typeof item !== 'object') return '';
      if (item.item_type == 'link') return item.link.link_context.link_summary;
      // item_type: xma の場合
      if (item.item_type == 'xma') return item.xma.caption_body_text || item.xma.subtitle_text || item.xma.header_subtitle_text;
      if (item[item.item_type] && item[item.item_type][0]) { 
        const obj = item[item.item_type][0];
        return obj.caption_body_text || obj.subtitle_text || obj.header_subtitle_text;
      }
      return '';
    },
    isKnownType(type) {
      return [
        'text', 'media', 'raven_media', 'media_share', 'voice_media', 'placeholder', 
        'link', 'xma_link', 'xma_reel_mention', 'xma_clip', 'generic_xma', 
        'xma_reel_share', 'xma_story_share', 'xma_media_share', 'xma_profile',
        'action_log', 'animated_media', 'sticker', 'location', 'video_call_event',
        'felix_share', 'live_video_share', 'location_share_xma', 'xma'
      ].includes(type);
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    lastActivity(val) {
      const now = new Date().getTime();
      const lastUpdate = val;
      const diffSec = now - lastUpdate;
      if (diffSec / (1000 * 60 * 60 * 24 * 7 * 4) > 1) {
        const diffMonth = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7 * 4)) + "ヶ月前";
        return diffMonth;
      } else if (diffSec / (1000 * 60 * 60 * 24 * 7) > 1) {
        const diffWeek = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7)) + "週間前";
        return diffWeek;
      } else if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
    timestampToDate(val) {
      return new Date(val / 1000).toLocaleDateString();
    },
    timestampToTime(val) {
      return new Date(val / 1000).toLocaleString().slice(0, -3);
    },
    urlActivate(value) {
      const url_keyword = "((ftp|http|https)://)?[-_.!~*'()a-zA-Z;/?:@&=+$,%#]+[.]+[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+";
      const keyword_RegExp = new RegExp(url_keyword, "ig");
      return value.replace(keyword_RegExp, (keyword) =>
          keyword.match(/ftp|http|https/)
              ? '<a style="color:inherit; text-decoration: underline" href="' + keyword + '" target="_blank">' + keyword + "</a>"
              : '<a style="color:inherit; text-decoration: underline" href="https://' + keyword + '" target="_blank">' + keyword + "</a>"
      );
    },
  },
  watch: {
    thread_id() {
      if (this.referer == "message" && this.thread_id != "") {
        this.openThread();
      }
    },
    ig_id() {
      if (this.referer == "idetail") {
        this.userThread();
      }
    },
    sessionid() {
      if (this.referer == "message") {
        this.thread_id = "";
      } else {
        this.userThread();
      }
    },
    inputting() {
      if (this.inputting == false) {
        this.saveMessage();
      }
    },
  },
};
</script>
